// extracted by mini-css-extract-plugin
export default {"panelContent":"EoBwRwO5_ZfbacZjN1cs","blocksGrid":"HdFtKHG_Z0G92CD1LWTf","block":"_DpRlBmh82ZsKtJtd9e1","icon":"kpj0PrmyXJh2SOILTiEN"};